import type { ApiProviderProfile } from '../types/matchmaking.types';

export const formatServiceAreaString = (serviceArea: any): string => {
  if (!serviceArea || typeof serviceArea !== 'object') {
    return '-';
  }

  const states: string[] = [];
  Object.entries(serviceArea).forEach(([state, counties]: [string, any]) => {
    if (state) {
      if (Array.isArray(counties) && counties.length > 0) {
        states.push(`${state} (${counties.join(', ')})`);
      } else {
        states.push(state);
      }
    }
  });

  return states.length > 0 ? states.join('; ') : '-';
};

export const mapBackendProviderToProfile = (
  provider: any,
): ApiProviderProfile & { name?: string; serviceArea?: string; aiRationale?: string; distanceMiles?: number } => {
  const serviceAreaString = formatServiceAreaString(provider.serviceArea);

  return {
    provider_id: provider.providerId,
    acceptsNewClients: true,
    categories: [],
    specialties: [],
    expertise_areas: [],
    latitude: 0,
    longitude: 0,
    rating: provider.google_reviews_rating || 0,
    reviewsTotalNumber: 0,
    years_experience: 0,
    typical_cost_range_min: 0,
    typical_cost_range_max: 0,
    cost_unit: '',
    pricing_model: '',
    registeredStates: [],
    service_ranges: provider.service_ranges || [],
    licensedRegions: [],
    emergency_response_available: false,
    availability_schedule: '',
    doc_type: '',
    badges: provider.badges || [],
    name: provider.companyName,
    serviceArea: serviceAreaString,
    aiRationale: provider.aiData?.aiRationale || undefined,
    distanceMiles: provider.distanceMiles,
  };
};

